/**
 * Moved to `@sizzlenz/shared-frontend/api` so both frontends share one API client.
 * This file stays as a re-export so existing `@/lib/api/client` imports keep working.
 */
export {
  apiClient,
  authenticatedApiClient,
  createAuthenticatedRequest,
  configureApiClient,
  getApiBaseUrl,
  type ApiClientConfig,
} from '@sizzlenz/shared-frontend/api';
